import {
  AVAILABLE_WAREHOUSES_URL,
  CONTRACTED_MATCH_LIST,
  LSP_WAREHOUSES_URL,
} from '@constants';
import { AxiosInstance } from 'axios';
import {
  WarehouseOption,
  WarehouseOptionsShipperResponse,
  WarehouseOptionsLspResponse,
  WarehouseClientOptionResponse,
  WarehouseClientOption,
} from '@hooks';

export const fetchShipperWarehouses = async (
  authHttp: AxiosInstance
): Promise<WarehouseOption[]> => {
  const {
    data: { matches },
  } = await authHttp.post<WarehouseOptionsShipperResponse>(
    AVAILABLE_WAREHOUSES_URL,
    {
      searchQuery: '',
      pagination: {
        lastItemSort: null,
      },
      itemsPerPage: 100,
    }
  );

  return matches.map((match) => ({
    warehouseId: match.match.warehouseId,
    warehouseName: match.match.warehouseName,
  }));
};

export const fetchLspWarehouses = async (
  authHttp: AxiosInstance
): Promise<WarehouseOption[]> => {
  const {
    data: { warehouses },
  } = await authHttp.post<WarehouseOptionsLspResponse>(LSP_WAREHOUSES_URL, {
    searchQuery: '',
    isGettingFromAllBusinesses: true,
    pagination: {
      lastItemSort: null,
      itemsPerPage: 100,
    },
  });

  return warehouses.map((warehouse) => ({
    warehouseId: warehouse.warehouseId,
    warehouseName: warehouse.name,
  }));
};

const dedupeClientsByBusinessId = (
  clients: WarehouseClientOption[]
): WarehouseClientOption[] => {
  const seenBusinessIds = new Set<string>();
  return clients.filter((client) => {
    if (seenBusinessIds.has(client.userBusinessId)) return false;
    seenBusinessIds.add(client.userBusinessId);
    return true;
  });
};

export const fetchWarehouseClients = async (
  authHttp: AxiosInstance,
  searchQuery = ''
): Promise<WarehouseClientOption[]> => {
  const {
    data: { matches },
  } = await authHttp.post<WarehouseClientOptionResponse>(
    CONTRACTED_MATCH_LIST,
    {
      searchQuery,
      pagination: {
        lastItemSort: null,
        itemsPerPage: 100,
      },
    }
  );

  return dedupeClientsByBusinessId(matches.map((match) => match.match));
};
